// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResponsiveLayout_wrapper__N75qG","contents-wrapper":"ResponsiveLayout_contents-wrapper__Wtg5a"};